module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-schweiz-circle-b419b90128eb8ffbd22a61ba3f28ae95.svg";